export default {
	props: {
		patient: {
			type: Array,
			required: true
		},

		column: {
			type: Object
		},

		step: {
			type: Number,
			required: true
		}
	},

	computed: {
		invalidPatient() {
			return this.patient.filter((patient) => patient.invalid)
		},
		unconfirmedPatient() {
			return this.patient.filter((patient) => (! patient.invalid && patient.confirmed != null))
		}
	}
}
